module.exports = __webpack_public_path__ + "static/media/icon-sidemenu.acc6dd02.svg";